import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/CategoryBarChart.css";

/**
 * Horizontal ranked bar chart of active post counts per category.
 * Each row links through to that category's post list.
 */
export default function CategoryBarChart({ categories, counts }) {
  const [ready, setReady] = useState(false);

  const rows = categories
    .map((cat) => ({ ...cat, count: counts[cat.label] ?? 0 }))
    .sort((a, b) => b.count - a.count);

  const maxCount = Math.max(1, ...rows.map((r) => r.count));

  useEffect(() => {
    // Mount bars at 0% width, then grow them — gives the chart a load-in animation.
    const t = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(t);
  }, []);

  return (
    <div className="barchart">
      {rows.map((row, index) => (
        <Link
          key={row.key}
          to={`/category/${row.key}`}
          className={"barchart-row" + (index === 0 ? " barchart-row-top" : "")}
        >
          <div className="barchart-row-label">
            <span className="barchart-icon">{row.icon}</span>
            <span className="barchart-name">{row.label}</span>
            {index === 0 && row.count > 0 && (
              <span className="barchart-top-tag">Top</span>
            )}
          </div>

          <div className="barchart-track">
            <div
              className="barchart-fill"
              style={{ width: ready ? `${(row.count / maxCount) * 100}%` : "0%" }}
            />
          </div>

          <div className="barchart-value">{row.count}</div>
        </Link>
      ))}
    </div>
  );
}
